import React, { useState } from "react";
import { COMPLAINT_STATUS } from "../../utils/complaintHelpers";
import "./ComplaintResponseModal.css";

const STATUS_OPTIONS = [
  { value: COMPLAINT_STATUS.IN_PROGRESS, label: "قيد المعالجة" },
  { value: COMPLAINT_STATUS.RESOLVED, label: "تم الحل (إغلاق)" },
  { value: COMPLAINT_STATUS.REJECTED, label: "مرفوض" },
];

export default function ComplaintResponseModal({
  isOpen,
  onClose,
  onSubmit,
  complaint,
}) {
  const [status, setStatus] = useState(COMPLAINT_STATUS.IN_PROGRESS);
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");

  if (!isOpen || !complaint) return null;

  function handleSubmit(e) {
    e.preventDefault();
    if (!response.trim() || response.trim().length < 3) {
      setError("السبب مطلوب");
      return;
    }
    onSubmit({ status, response: response.trim() });
    setResponse("");
    setError("");
    setStatus(COMPLAINT_STATUS.IN_PROGRESS);
  }

  function handleClose() {
    setResponse("");
    setError("");
    setStatus(COMPLAINT_STATUS.IN_PROGRESS);
    onClose();
  }

  return (
    <div className="complaint-modal-overlay" onClick={handleClose}>
      <div className="complaint-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="complaint-modal-title">الرد على الشكوى</h3>
        <p className="complaint-modal-subtitle">
          من: {complaint.senderName} — {complaint.title}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="complaint-modal-field">
            <label className="complaint-modal-label">تغيير الحالة</label>
            <select
              className="complaint-modal-select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div className="complaint-modal-field">
            <label className="complaint-modal-label">السبب *</label>
            <textarea
              className={`complaint-modal-textarea ${error ? "has-error" : ""}`}
              rows={4}
              placeholder="اكتب سبب الرد..."
              value={response}
              onChange={(e) => {
                setResponse(e.target.value);
                if (error) setError("");
              }}
            />
            {error && <p className="complaint-modal-error">{error}</p>}
          </div>

          <div className="complaint-modal-buttons">
            <button
              type="button"
              className="complaint-modal-btn secondary"
              onClick={handleClose}
            >
              إلغاء
            </button>
            <button type="submit" className="complaint-modal-btn primary">
              إرسال الرد
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
